<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 41 95"
         xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="Слой_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer"></metadata>
         <path class="fill-black" d="M11 70c6,-12 12,-10 16,4 2,5 7,13 13,21 -8,-5 -12,-12 -15,-19 -4,-10 -9,-10 -13,0 -4,10 -8,16 -12,19 7,-9 7,-18 11,-25z"></path>
         <path class="inter-fill inter-stroke" :class="{'inter-active':selected}" d="M25 8c2,-4 10,-4 11,0 3,14 -1,28 -12,44 -1,2 -1,3 -6,3 -5,0 -12,-13 -17,-28 0,-3 0,-6 0,-9 4,-10 9,-19 15,-18 6,1 6,4 10,7z"></path>
     </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]

    }
</script>

<style scoped>

</style>
